<template>
  <Loader
    id="global-loader"
    :variant="variant"
    :msg="globalLoadingMsg">
  </Loader>
</template>

<script>
export default {
  name: 'GlobalLoader',
  props: ['variant'],
  data() {
    return {
      globalLoadingMsg: '',
    };
  },
  methods: {
    show(msg) {
      this.globalLoadingMsg = msg;
      document.documentElement.classList.add('overflow-hidden');
    },
    hide() {
      this.globalLoadingMsg = '';
      document.documentElement.classList.remove('overflow-hidden');
    },
  },
  created() {
    this.$root.$on('show-global-loader', this.show);
    this.$root.$on('hide-global-loader', this.hide);
  },
};
</script>
